import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';
import Svg, { Rect, Path } from '@dbk/ui-svg';
import { PALETTE } from '../../../constants';

const iconOuterPath =
  'M8.25,0 L8,0.3333 L8,2 L7,2 L7,1 L5,1 L5,2 L4,2 L4,0.3333 L3.75,0 L3.25,0' +
  ' L3,0.3333 L3,2 L2,2 L2,1 L0.75,1 L0,2 L0,11 L0,11 L0.75,12 L11.25,12 L12,11 L12,2 L11.25,1' +
  ' L10,1 L10,2 L9,2 L9,0.3333 L8.75,0 L8.25,0 Z M1,11 L11,11 L11,4 L1,4 L1,11 Z';

function Icon({ color }) {
  return (
    <Svg width="12" height="13" viewBox="0 0 12 13">
      <Path d={iconOuterPath} fill={color} fillRule="evenodd" />
      <Rect fill={color} x="2" y="5" width="2" height="2" />
      <Rect fill={color} x="5" y="5" width="2" height="2" />
      <Rect fill={color} x="8" y="5" width="2" height="2" />
      <Rect fill={color} x="2" y="8" width="2" height="2" />
      <Rect fill={color} x="5" y="8" width="2" height="2" />
    </Svg>
  );
}

Icon.propTypes = {
  color: PropTypes.string,
};

Icon.defaultProps = {
  // Match the text colour
  color: PALETTE.primaryText,
};

export default pure(Icon);
